import { Box } from "@mui/material"
import { useParams } from "@tanstack/react-router"
import type { FC } from "react"

import useGetProductInstructions from "../../Instructions/hooks/useGetProductInstructions"
import { useGetProductAislesPreferences, useGetProductShelvingRequirement } from "../hooks"

import ProductAislesPreferencesSection from "./ProductAislesPreferences/ProductAislesPreferencesSection"
import ProductShelvingRequirementSection from "./ProductShelvingRequirement/ProductShelvingRequirementSection"
import ProductStorageInstructionsPanel from "./ProductStorageInstructionsPanel"

import { IncludeWithEnum } from "@/graphql/codegen/graphql"

const ProductStorageContainer: FC = () => {
  const params = useParams({ strict: false })
  const productId = Number(params.productId)
  const {
    shelvingRequirement,
    isFetching: isFetchingShelvingRequirements,
    refetch: refetchShelvingRequirements,
  } = useGetProductShelvingRequirement(productId)
  const {
    aislesPreferences,
    isFetching: isFetchingAislesPreferrences,
    refetch: refetchPreferredAisles,
  } = useGetProductAislesPreferences(productId)
  const { productInstructions } = useGetProductInstructions({
    productId,
  })
  const putawayInstructions = productInstructions.filter(({ includeWith }) =>
    includeWith.includes(IncludeWithEnum.Putaway)
  )

  return (
    <Box className='flex flex-col gap-y-6'>
      <ProductShelvingRequirementSection
        productId={productId}
        shelvingRequirements={shelvingRequirement}
        isFetching={isFetchingShelvingRequirements}
        onRefresh={() => refetchShelvingRequirements()}
      />
      <ProductAislesPreferencesSection
        productId={productId}
        aislesPreferences={aislesPreferences}
        isFetching={isFetchingAislesPreferrences}
        onRefresh={() => refetchPreferredAisles()}
      />
      {putawayInstructions.length > 0 && <ProductStorageInstructionsPanel instructions={putawayInstructions} />}
    </Box>
  )
}

export default ProductStorageContainer
